/**
 * Created by Константин on 28.05.2017.
 */
class Selectors {
  constructor() {
    this._sid = null;
    this._page = null;
    this._pids = {};
    this._ids = [];
    this._service = false;
  }

  get page() {
    return this._page;
  }

  set page(value) {
    this._page = value;
    if (typeof this._pids[value] === 'undefined') {
      this._pids[value] = [];
    }
  }

  get pids() {
    return this._pids;
  }

  set pids(value) {
    if (value === -1) {
      this._pids[this._page] = [];
    }
    else {
      if (-1 === this._pids[this._page].indexOf(value)) {
        this._pids[this._page].push(value);
        const idx = this._ids.indexOf(value);
        if (idx > -1) this._ids.splice(idx, 1);
      }
    }
  }

  get ids() {
    let v;
    const d = this._ids.slice(0);
    for (const val in this._pids) {
      v = this._pids[val];
      if (v.length > 0) {
        for (let i = 0; i < v.length; i++) {
          d.push(v[i])
        }
      }
    }
    return d;
  }

  get sid() {
    const d = [];
    for (const val in this._pids) {
      d.push(this._pids[val].join(','));
    }
    if (this._ids.length > 0) d.push(this._ids.join(','));
    return d.join(',');
  }

  set sid(value) {
    this._sid = value;
    this._ids = (!!value) ? [] : value.split(',');
    this._page = null;
    this._pids = {};
    this._service = false;
  }

  get service() {
    return this._service;
  }

  set service(value) {
    this._service = value;
  }

  removePid() {
    const idx = this._pids[this._page].indexOf(value);
    if (idx > -1) {
      this._pids[this._page].splice(idx, 1);
    }
  }
}
